import {postMethod} from '@/api'
export const post = async request => await postMethod('/api/prepareModifyService', request)
